import React from 'react';
import { FileEdit } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';

export default function FormTemplates() {
  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-pink-500 to-pink-600 p-3 rounded-lg">
            <FileEdit className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Form Templates</h1>
            <p className="text-sm text-gray-500">Manage recruitment form templates</p>
          </div>
        </div>
      </div>
      <Card className="mt-6 shadow-sm">
        <CardContent className="text-center py-12">
          <FileEdit className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500">No templates available</p>
        </CardContent>
      </Card>
    </div>
  );
}